import { render, staticRenderFns } from "./ClassAttendanceTab.vue?vue&type=template&id=82e719b0&scoped=true"
import script from "./ClassAttendanceTab.vue?vue&type=script&lang=js"
export * from "./ClassAttendanceTab.vue?vue&type=script&lang=js"
import style0 from "./ClassAttendanceTab.vue?vue&type=style&index=0&id=82e719b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e719b0",
  null
  
)

export default component.exports